import JoinModalWithButtons from './JoinModalWithButtons';

export default JoinModalWithButtons;
